<template>
  <NavBar />
  <header class="lg:px-16 px-5 bg-white flex flex-wrap items-center py-3">
    <div class="flex-1 flex justify-between items-center">
      <div class="relative">
        <a href="javascript.void(0)" class="block text-3xl font-redHat text-[#F5CA40] font-bold">
          Laporan List Orderan
        </a>
        <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Verifikasi Data</p> -->
      </div>
      <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Story Instagram</p> -->
    </div>

    <div class="hidden md:flex md:items-center md:w-auto w-full" id="menu">
      <nav>
        <ul class="md:flex items-center justify-between text-base text-gray-700 pt-3 md:pt-0 gap-1">
          <li class="" v-if="this.records.length == 0 && status_generate">
            <!-- <div @click="generate"
              class="font-redHat text-base  h-[40px] w-[243px] rounded-md text-white  border-2 bg-green-600 me-2 cursor-pointer">
              <div class="flex justify-center items-center h-full gap-2">
                <img src="../../../assets/img/refresh.png" alt="">
                Generate
              </div>
            </div> -->
          </li>
          <li v-if="this.records && this.records.length > 0">
            <div @click="convertToExcel"
              class="font-redHat text-base  h-[40px] w-[150px] rounded-md text-green-600  border-2 border-green-600 me-2 cursor-pointer">
              <div class="flex justify-center items-center h-full gap-2">
                <img src="../../../assets/img/icon_excel.png" alt="">
                Export Excel
              </div>
            </div>
          </li>
          <li>
            <div
              class="relative flex items-center p-0 rounded-[8px] w-[250px] max-w-lg h-[40px] border-[0.5px] border-[#00000]">
              <input type="text" v-model="searchQuery" @input="filterTable"
                class="rounded-[8px] p-2.5 px-6 w-full h-full focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
                name="search" placeholder="Cari">
              <button type="submit"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white  p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
              </button>
            </div>
          </li>
          <li>
            <input type="date" v-model="date" class="flex-grow border-1 border-[#5FBAE6] rounded-md p-2"
              name="date_choose">
            <!-- <Datepicker v-model="dateRange" range="true" lang="id" class="" position="right" /> -->
          </li>

          <!-- <div class="relative p-0 rounded-[20px] w-[250px] max-w-lg"> -->
          <!-- <input type="text" class="rounded-[20px] p-3 w-full" name="search" placeholder="Cari"> -->
          <!-- </div> -->
          <!-- <li>
              <RouterLink to="addcustomer"
                class="md:p-4 py-3 block flex items-center justify-center w-[200px] h-[40px] rounded-md bg-[#50C996] text-black py-2.5 font-semibold"
              >
                Customer Baru
              </RouterLink>
            </li> -->

          <!-- <input type="date" v-model="date" class="flex-grow border-1 border-[#5FBAE6] rounded-md p-2" name="date"> -->
          <!-- <li>
            <button @click="filterDropdown = !filterDropdown" id="dropdownHoverButton"
              class="md:p-4 py-3 px-0 block flex items-center justify-center w-[100px] h-[40px] rounded-md bg-[#F5CA40] text-black px-6 py-2.5 font-semibold gap-2">
              Filter By <i class="bi bi-funnel-fill"></i>
            </button>
            <ul v-if="filterDropdown"
              class="absolute transform -translate-x-2  bg-slate-100 shadow-lg mt-2 rounded-lg w-30 space-y-2 p-1"> 
              <li
                class="block px-4 py-2 text-black font-redHat text-base hover:bg-[#5FBAE6]/80 hover:rounded-lg cursor-pointer"
                :class="{ 'bg-[#5FBAE6]/80 rounded-lg': selectedType === 'STORY_IG' }"
                @click="filterRecords('STORY_IG')">
                <div>List Order</div>
              </li>
              <li
                class="block px-4 py-2 text-black font-redHat text-base hover:bg-[#5FBAE6]/80 hover:rounded-lg cursor-pointer"
                :class="{ 'bg-[#5FBAE6]/80 rounded-lg': selectedType === 'LIVE_IG' }" @click="filterRecords('LIVE_IG')">
                <div>Live Instagram</div>
              </li>
            </ul>
          </li> -->
        </ul>
      </nav>
    </div>
  </header>

  <div class="px-5 pt-5 mb-2">

    <div class="overflow-scroll" style="max-height: 60vh;">
      <!-- for datatable -->
      <table id="example" class="display" style="width: 100%;">
        <thead style="position: sticky; top: 0; background-color: white; z-index: 1;">
          <tr v-if="filteredRecords.length > 0">
            <th style="width: 5%">No.</th>

            <th style="width: 20%" @click="sortColumn('instagram')" class="cursor-pointer ">
              Instagram
              <i v-if="sortKey === 'instagram' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'instagram' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 30%" @click="sortColumn('name')" class="cursor-pointer">
              Nama Customer
              <i v-if="sortKey === 'name' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'name' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <!-- <th style="width: 15%" @click="sortColumn('total_deposit')" class="cursor-pointer">
              Total Deposit
              <i v-if="sortKey === 'total_deposit' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'total_deposit' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th> -->


            <th style="width: 15%" @click="sortColumn('total_sales')" class="cursor-pointer">
              Total Sales
              <i v-if="sortKey === 'total_sales' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'total_sales' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 10%" @click="sortColumn('nama_admin')" class="cursor-pointer">
              Nama Admin
              <i v-if="sortKey === 'nama_admin' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'nama_admin' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 10%" @click="sortColumn('type')" class="cursor-pointer">
              Type
              <i v-if="sortKey === 'type' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'type' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr-table" v-for="(item, index) in filteredRecords" :key="item.id">
            <td class="custom-td-left">{{ index + 1 }}</td>
            <td class="">
              <div class="m-2">{{ item.instagram }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.name }}</div>
            </td>
            <!-- <td class="">
              <div class="m-2">{{ rupiah(item.total_deposit) }}</div>
            </td> -->
            <td class="">
              <div class="m-2">{{ rupiah(item.total_sales) }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.nama_admin }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.type }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>




  <!-- modal delete -->
  <div v-if="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <!-- Modal content -->
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full" @click.stop>
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Delete Data Rekap</h2>
        <button @click="closeModal" class="text-red-600 hover:text-gray-900">
          ✕
        </button>
      </div>
      <p class="text-gray-700 mb-10">
        Are you sure wants to delete this data ?
      </p>

      <div class="space-y-3">
        <div aria-hidden="true" class="border-t px-2"></div>
        <div class="button-group flex justify-end">
          <button @click="closeModal" class="bg-gray-400 text-white font-bold py-2 px-4 rounded hover:bg-gray-700 me-3">
            Close
          </button>
          <button @click="delete2" class="bg-red-500 text-white font-bold py-2 px-4 rounded hover:bg-red-700">
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import NavBar from '@/components/NavBar.vue'
import axios from "axios";
// import Swal from 'sweetalert2';

import { ErrorConnectionTimeOut, ShowLoading, CloseLoading, base_url, AlertPopup, AlertBottom, rupiahInput, rupiah, goPage, DateFormat, currencyInput } from "@/assets/js/function";
// import {ErrorConnectionTimeOut,  ShowLoading, CloseLoading, base_url, AlertPopup,  rupiahInput,  rupiah } from "@/assets/js/function";
import Cookies from "js-cookie";
import Multiselect from 'vue-multiselect';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueDatepickerUi from 'vue-datepicker-ui';
import XLSX from "xlsx/dist/xlsx.full.min.js";

export default {
  components: {
    NavBar,
    Multiselect,
    Datepicker: VueDatepickerUi
  },

  data() {
    return {
      searchQuery: '',

      records: [
        {
          total_deposit: '',
        }
      ],
      currentData: [],
      listStatusPesanan: [],
      isModalOpen: false,
      currentDeleteIndex: null,
      config: '',
      filterDropdown: false,
      selectedType: 'LIVE_IG',
      // total: 0,

      date: new Date(),

      dateRange: [
        new Date(),
        new Date()],
      // currency: "",

      sortKey: '',         // Column key to sort by
      sortDirection: 'asc', // Sort direc

      status_generate: true,
    }
  },

  watch: {
    date: {
      handler(newVal) {
        this.index();

        // Convert both dates into Date objects for proper comparison
        const dateToCompare = new Date();
        dateToCompare.setHours(0, 0, 0, 0); // Set time to 00:00:00.000

        const storedDate = new Date(this.date);
        storedDate.setHours(0, 0, 0, 0); // Set time to 00:00:00.000

        // Compare the time values of the two dates
        if (storedDate.getTime() !== dateToCompare.getTime()) {
          this.status_generate = false;
        } else {
          this.status_generate = true;
        }
      },
    }
    // dateRange: {
    //   handler(newVal) {
    //     this.index();
    //   },
    // }
  },

  created() {
    const token = Cookies.get("token");
    // console.log(token)
    this.config = {
      headers: { Authorization: `Bearer ` + token },
      timeout: 100000,
    }

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');

    this.date = `${year}-${month}-${day}`; // Output: '2024-05-01'


    // console.log(this.config);
    this.index();
    this.prepareData();


    this.showMultiselect = false;

    // Load from localStorage when the component is created
    // const savedLiveIg = localStorage.getItem('records');
    // if (savedLiveIg) {
    // this.records = JSON.parse(savedLiveIg); // Load saved data into records
    // console.log('Stored records:', JSON.parse(savedLiveIg));
    // }else {
    // console.log('No records found in localStorage.');
    // }
  },

  computed: {
    filteredRecords() {
      let records = [...this.records];

      // Filter records based on search query
      if (this.searchQuery) {
        const searchLower = this.searchQuery.toLowerCase();
        records = records.filter(item => {
          return (
            (item.supplier_name ? item.supplier_name.toLowerCase().includes(searchLower) : false) ||
            (item.category ? item.category.toLowerCase().includes(searchLower) : false) ||
            (item.code ? item.code.toLowerCase().includes(searchLower) : false) ||
            (item.name ? item.name.toLowerCase().includes(searchLower) : false) ||
            (item.instagram ? item.instagram.toLowerCase().includes(searchLower) : false) ||
            (item.qty ? String(item.qty).includes(searchLower) : false) ||
            (item.cost_price ? String(item.cost_price).includes(searchLower) : false) ||
            (item.total ? String(item.total).includes(searchLower) : false)
          );
        });
      }

      // Sort records based on the selected column and direction
      if (this.sortKey) {
        records.sort((a, b) => {
          const valueA = a[this.sortKey];
          const valueB = b[this.sortKey];

          if (typeof valueA === 'string') {
            // If the values are strings, compare them alphabetically
            return this.sortDirection === 'asc'
              ? valueA.localeCompare(valueB)
              : valueB.localeCompare(valueA);
          } else {
            // If the values are numbers, compare them numerically
            return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
          }
        });
      }

      return records;
    }
  },


  // mounted() {
  //     this.$root.initializeDataTable(); 

  // },

  methods: {

    rupiah,
    currencyInput,
    addNumberToObjects(objArray) {
      for (let i = 0; i < objArray.length; i++) {
        const { instagram, name, total_sales, nama_admin, type, ...rest } = objArray[i];  // Extract fields to be renamed
        const newObj = {
          No: i + 1,
          "Tanggal": this.date,
          "Instagram": instagram,  // Rename id_customer to customer_id
          "Nama Customer": name,  // Rename id_customer to customer_id
          "Total Sales": total_sales,
          "Nama Admin": nama_admin,
          "Tipe": type,
          ...rest
        };
        objArray[i] = newObj;
      }
      return objArray;
    },
    convertToExcel() {
      ShowLoading();

      // Create a deep copy of `this.records` to avoid modifying the original data
      const data = JSON.parse(JSON.stringify(this.records));
      const ArrExport = this.addNumberToObjects(data);

      for (let i = 0; i < ArrExport.length; i++) {
        delete ArrExport[i]["id"];
        delete ArrExport[i]["id_customer"];
        delete ArrExport[i]["normal_price"];
        delete ArrExport[i]["qty"];
        delete ArrExport[i]["status_customer"];
        delete ArrExport[i]["customer_detail"];
        delete ArrExport[i]["list_order"];
      }

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      // Create a new worksheet
      const ws = XLSX.utils.json_to_sheet(ArrExport);
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'REKAP');
      // Convert the workbook to an XLSX file and download it
      XLSX.writeFile(wb, 'LIST ORDER REPORT' + ".xlsx");
      CloseLoading();
    },
    sortColumn(column) {
      if (this.sortKey === column) {
        // Toggle sort direction if already sorting by this column
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Set sort key to new column and default direction to ascending
        this.sortKey = column;
        this.sortDirection = 'asc';
      }
    },
    nameWithLang({ name }) {
      return `${name}`;
    },

    addRow() {
      // Mark the row as "Added"
      //   this.record[index].isAdded = true

      // Add a new row with a unique id
      this.records.push({
        id_customer: '',
        id_produk: '',
        color: '',
        size: '',
        qty: '',
        price: '',
        deposit: '',
        isAdded: false
      })
    },
    getIconClass(item) {
      // Determine the icon class based on whether the row is the last one
      // return item.total_deposit > item.price ? 'bi bi-check-circle-fill text-gray-400' : 'bi bi-check-circle-fill text-[#50C996]' ;
      // console.log(item.total_deposit)
      // console.log(item.price)
      if (item.total_deposit >= item.price) {
        //return 'bi bi-check-circle-fill text-[#50C996]'; // Green verified
        return true
      }
      else {
        //return 'bi bi-check-circle-fill text-gray-400'; // Gray unverified
        return false
      }
    },
    formatCurrency(label, number, index) {
      this.records[index][label] = rupiahInput(number);
    },
    prepareData() {
      // this.records.total_deposit = rupiahInput(this.records.total_deposit);
      this.records.forEach((item) => {
        item.total_deposit = rupiahInput(item.total_deposit);
      });

    },
    editData(item) {
      // for batal edit customer page
      localStorage.setItem('currentData', JSON.stringify(item));
      goPage('accept');

    },
    editCustomer(item) {
      // for batal edit customer page
      this.$router.push({ name: 'editcustomer' });
      sessionStorage.setItem('lastPage', 'verifikasi-live-ig');

      // console.log(item)
      localStorage.setItem('currentData', JSON.stringify(item.customer_detail));

      // Navigate to the Add Customer page
      this.$router.push({ name: 'editcustomer' });
    },
    filterRecords(type) {
      this.selectedType = type; // Save the selected filter type
      this.index(); // Call the index method to fetch filtered data
    },

    index() {
      ShowLoading();
      let formData = new FormData();

      formData.append('id_preorder', localStorage.getItem('id_preorder'))
      formData.append('date', this.date);
      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'list_order_report';
      } else {
        this.api = base_url + 'list_order_report';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status === true) {
            this.records = response.data.data;

            localStorage.getItem('id_preorder');
            CloseLoading();
          } else {
            CloseLoading();
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          CloseLoading();
          ErrorConnectionTimeOut(error);
        });
    },
    // generate() {
    //   ShowLoading();
    //   let formData = new FormData();

    //   formData.append('id_preorder', localStorage.getItem('id_preorder'))
    //   formData.append('date', this.date);
    //   if (process.env.NODE_ENV === "development") {
    //     this.api = base_url + 'generate_buy_summary';
    //   } else {
    //     this.api = base_url + 'generate_buy_summary';
    //   }

    //   axios
    //     .post(this.api, formData, this.config)
    //     .then((response) => {
    //       if (response.data.status === true) {
    //         this.records = [];
    //         this.total = response.data.total_result_value;
    //         this.currency = response.data.currency;

    //         this.index();

    //         CloseLoading();
    //       } else {
    //         CloseLoading();
    //         AlertPopup("error", "", response.data.message, 1500, false);
    //       }
    //     })
    //     .catch((error) => {
    //       CloseLoading();
    //       ErrorConnectionTimeOut(error);
    //     });
    // },
    openModalDelete() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.id_terminate = null;
    },
    delete2() {
      ShowLoading();
      let formData = new FormData();
      formData.append("id", this.id_terminate);

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'live_ig_delete';
      } else {
        this.api = base_url + 'live_ig_delete';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {

          if (response.data.status == true) {
            const index = this.records.findIndex((item) => item.id === this.id_terminate); // Find item in the array by ID
            this.records.splice(index, 1); // Remove the item from the array
            CloseLoading();
            this.closeModal(); // Close modal after deletion
            AlertBottom(response.data.message);

          } else {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {

          ErrorConnectionTimeOut(error);
        });


    },
    terminate(id) {
      this.id_terminate = id;
      this.openModalDelete();
      // this.tanggal_terminate = new Date();

    },


  }
}
</script>

<style scoped>
/* Adjust positioning and z-index for the multiselect dropdown */
.multiselect__content {
  position: absolute;
  z-index: 9999;
  top: 100%;
}

.multiselect-full-width .multiselect__select {
  width: 100%;
}

.no-arrows {
  -moz-appearance: textfield;
  /* Firefox */
  appearance: none;
  /* Remove default appearance */
}

.no-arrows::-webkit-outer-spin-button,
.no-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome, Safari, Edge */
  margin: 0;
  /* Remove margin */
}
</style>